<template>
  <v-dialog scrollable v-model="dialog" persistent max-width="590">
    <v-card>
      <v-card-title class="subtitle-1">{{ $t('cgu.title') }}</v-card-title>
      <v-card-text class="cgutext" v-html="$t('cgu.text')" style="font-size: 0.7em"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close()">{{ $t('cgu.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: [],
  data() {
    return {};
  },
  computed: {
    ...mapState('CGU', ['status']),
    dialog: {
      get() {
        return this.status;
      },
    },
  },
  watch: {},
  mounted() {},
  created() {},
  methods: {
    ...mapActions('CGU', { open: 'open', close: 'close' }),
  },
};
</script>

<style scoped>
.cgutext {
  font-size: 0.7em;
  line-height: 1em;
}
</style>